import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConservazioneCaricaDocumentoDocumentiDoganaliEmessiStep2Component
} from './conservazione-carica-documento-documenti-doganali-emessi-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-documenti-doganali-emessi-step2', {
            url: '/conservazione-carica-documenti-doganali-emessi',
            ncyBreadcrumb: {
                label: 'Carica Documenti Doganali Emessi',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-documenti-doganali-emessi-step2 flex="100"></conservazione-carica-documento-documenti-doganali-emessi-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoDocumentiDoganaliEmessiStep2Module: string = ng
    .module('conservazione-carica-documento-documenti-doganali-emessi-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoDocumentiDoganaliEmessiStep2', ConservazioneCaricaDocumentoDocumentiDoganaliEmessiStep2Component)
    .config(stateConfig)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-documenti-doganali-emessi-step2/conservazione-carica-documento-documenti-doganali-emessi-step2.module.ts